import {Component, OnInit} from '@angular/core';
import {animate, AnimationEvent, keyframes, state, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';

@Component({
  selector: 'app-section1',
  templateUrl: './section1.component.html',
  styleUrls: ['./section1.component.scss'],
  animations: [
    trigger('fadeInTrigger', [
      // ...
      state('shown', style({
        opacity: 1
      })),
      state('hidden', style({
        opacity: 0
      })),
      transition('* => shown', [
        animate('3s', keyframes([
          style({opacity: 0}),
          style({opacity: 0}),
          style({opacity: 1})
        ]))
      ])
    ])
  ]
})
export class Section1Component implements OnInit {

  titleState = 'shown';
  beginButtonState = 'hidden';


  constructor(private router: Router) {
  }

  onTitleFadedIn(event: AnimationEvent) {
    if (event.toState === 'shown') {
      this.beginButtonState = 'shown';
    }
  }

  ngOnInit(): void {
  }

  navigateToStart() {
    this.router.navigate(['/start']);
  }
}
